/**
 * The value behind "This file was already approved by [client|team member]"
 * (``PriorApprovalAttestation.vue``), and how an upload reads it.
 *
 * Card: Bug Intake #332 -- https://trello.com/c/fstQk6AK (GH #4292); team
 * member: Jake, 2026-10-27.
 *
 * Shape: ``{ attested, attester, clientId, memberId }``. ``attester`` is
 * ``'client'`` (the default, the original behavior) or ``'team_member'``;
 * only the id of the chosen attester is ever set.
 *
 * Both upload surfaces (the library's Add artwork dialog and the product
 * editor's upload pane) read it through these helpers, so "is it ready to
 * upload" and "what does the upload send" cannot drift between them.
 */

export const ATTESTER_CLIENT = 'client'
export const ATTESTER_TEAM_MEMBER = 'team_member'

export const PRIOR_APPROVAL_CLEARED = Object.freeze({
    attested: false,
    attester: ATTESTER_CLIENT,
    clientId: null,
    memberId: null,
})

/** A fresh, unticked value (default attester: client). */
export function clearedPriorApproval() {
    return { ...PRIOR_APPROVAL_CLEARED }
}

/** True when the value does not hold an upload back: unticked, or ticked with its attester picked. */
export function isPriorApprovalComplete(value) {
    if (!value?.attested) return true
    return value.attester === ATTESTER_TEAM_MEMBER
        ? value.memberId != null
        : value.clientId != null
}

/**
 * The ``uploadArtwork`` arguments the value implies: at most one of the two
 * ids is non-null, and both are null when the box is unticked.
 */
export function priorApprovalUploadArgs(value) {
    if (!value?.attested) {
        return { priorApprovalClientId: null, priorApprovalMemberId: null }
    }
    if (value.attester === ATTESTER_TEAM_MEMBER) {
        return {
            priorApprovalClientId: null,
            priorApprovalMemberId: value.memberId ?? null,
        }
    }
    return {
        priorApprovalClientId: value.clientId ?? null,
        priorApprovalMemberId: null,
    }
}
